import React, {FunctionComponent} from 'react'
import {useRootDispatch, useRootSelector} from '../../../utils/hooks'
import {ContactsUser} from '../../../responses/users'
import {contactsActions} from '../../../redux/pages/contacts/users'
import {Colors} from '../../../styles'
import styles from './ContactsPage.module.sass'
import SideMark from '../../etc/SideMark/SideMark'
import Down from 'files/chevron/down.svg'
import Up from 'files/chevron/up.svg'


const ContactsMobileLine: FunctionComponent<ContactsUser> = props => {
    const dispatch = useRootDispatch()
    const isOpen = useRootSelector(state => state.pages.contacts.openContacts)
    const open = isOpen.indexOf(props.name) !== -1
    let tel = props.phone
    tel = tel.replace('(', '')
    tel = tel.replace(')', '')
    tel = tel.replaceAll('-', '')

    return <div className={styles.line}>
        <div
            className={styles.lineHeader}
            onClick={() => dispatch(contactsActions.openContacts.toggle(props.name))}
        >
            <SideMark color={Colors.blue}/>
            <div className={styles.lineHeaderContacts}>
                <div>{props.name}</div>
                {
                    props.phone.length > 0 && <div className={styles.bold}><a href={'tel:'+ tel}>{props.phone}</a></div>
                }
            </div>
            <div className={styles.lineHeaderToggle}>

                {
                    open ? <Up/> : <Down/>
                }
            </div>
        </div>

        {
            open && <div className={styles.lineBody}>
                {
                    props.email && <div className={styles.lineBodyElement}>
                        <div className={styles.lineBodyElementTitle}>E-mail</div>
                        <div className={styles.lineBodyElementValue}>{props.email}</div>
                    </div>
                }
                {
                    props.directions.length > 1 && <div className={styles.lineBodyElement}>
                        <div className={styles.lineBodyElementTitle}>Направление</div>
                        <div className={styles.lineBodyElementValue}>{props.directions.map(dep => dep).join(', ')}</div>
                    </div>
                }
                {
                    props.departments.length > 1 && <div className={styles.lineBodyElement}>
                        <div className={styles.lineBodyElementTitle}>Отдел</div>
                        <div
                            className={styles.lineBodyElementValue}>{props.departments.map(dep => dep).join(', ')}</div>
                    </div>
                }
                {
                    props.position.length > 1 && <div className={styles.lineBodyElement}>
                        <div className={styles.lineBodyElementTitle}>Должность</div>
                        <div className={styles.lineBodyElementValue}>{props.position}</div>
                    </div>
                }
                {
                    props.skype && <div className={styles.lineBodyElement}>
                        <div className={styles.lineBodyElementTitle}>Скайп</div>
                        <div className={styles.lineBodyElementValue}>{props.skype}</div>
                    </div>
                }
            </div>
        }
    </div>
}

export default ContactsMobileLine
